import { type FC, useCallback, useMemo } from 'react';

import { useLocationForUndergrounMap } from '@/microfrontends/filters/shared/containers/UndergroundMapModalContainer/internal/hooks/useLocationForUndergrounMap';

import { useFiltersContext } from '../../utils/context';

import { Tag } from './internal/components/Tag';
import { TagsCollapsible } from './internal/components/TagsCollapsible';
import { UndergroundIcon } from './internal/components/UndergroundIcon';
import { getTagGroupConfig, getTags } from './internal/config';

export const TagsContainer: FC = () => {
  const context = useFiltersContext();

  const tags = useMemo(() => getTags(context), [context]);
  const regionId = useLocationForUndergrounMap();

  const handleClear = useCallback(() => {
    context.onChange({ action: 'clearTags', arguments: [] });
  }, [context]);

  if (!tags) {
    return null;
  }

  return (
    <TagsCollapsible onClear={handleClear}>
      {tags.map((tag, index) => {
        let prefix;
        const tagGroupConfig = getTagGroupConfig(tag);
        const handleClose = (): void => tagGroupConfig.delete(context, tag);

        if (tag.group === 'geoUnderground' && tag.data.color) {
          prefix = <UndergroundIcon color={tag.data.color} regionId={regionId} />;
        }

        return <Tag key={`tag_${index}`} prefix={prefix} text={tag.text} onClose={handleClose} />;
      })}
    </TagsCollapsible>
  );
};
